import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {ReachSnippetSource} from "./types";

type FetchSnippetVariables = {source: ReachSnippetSource; element_name: string};

type SnippetBody = {body: string};

const fetchSnippetFromCio = async (variables: FetchSnippetVariables): Promise<SnippetBody> => {
  const response = await axiosReachInstance.post<SnippetBody, AxiosResponse<SnippetBody>, FetchSnippetVariables>(
    "/snippets/fetch-cio",
    variables
  );
  return response.data;
};

export const useFetchSnippetFromCio = (
  options?: BaseMutationOptions<SnippetBody, FetchSnippetVariables>
): BaseUseMutationResult<SnippetBody, FetchSnippetVariables> =>
  useBaseMutation<SnippetBody, FetchSnippetVariables>(fetchSnippetFromCio, options);
